module.exports = __webpack_public_path__ + "static/media/img4.4d38845a.png";